import Layout from '../views/layout/App.vue'
import Empty from '../views/layout/Empty.vue'

export default {
	path: '/test_paper_manage',
	name: 'testPaperManages',
	meta: {
		title: '试卷列表',
		keepAlive: false
	},
	component: Empty,
	redirect: '/test_paper_manage',
	children: [
		{
			path: '',
			name: 'TestPaperManage',
			meta: {
				keepAlive: false
			},
			component: resolve => require(['@/views/examManage/testPaperManage/Index.vue'], resolve)
		},
		{
			path: 'preview_test_paper',
			name: 'PreviewTestPaper',
			meta: {
				title: '预览试题',
				keepAlive: false
			},
			component: resolve => require(['@/views/examManage/previewTestPaper/Index.vue'], resolve),
		}
	]
}
